import type { UseFormReturn } from "react-hook-form";

import { SalesCategoryNameField } from "~/components/settings/sales-category-form-fields";
import { Button } from "~/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "~/components/ui/dialog";
import { Form } from "~/components/ui/form";

export interface SalesCategoryFormValues {
  name: string;
}

export const EMPTY_SALES_CATEGORY_FORM_VALUES: SalesCategoryFormValues = {
  name: "",
};

interface SalesCategoryFormModalProps {
  description: string;
  form: UseFormReturn<SalesCategoryFormValues>;
  isSubmitting: boolean;
  onClose: () => void;
  onSubmit: (values: SalesCategoryFormValues) => void | Promise<void>;
  submitLabel: string;
  title: string;
}

export const SalesCategoryFormModal = ({
  description,
  form,
  isSubmitting,
  onClose,
  onSubmit,
  submitLabel,
  title,
}: SalesCategoryFormModalProps) => {
  return (
    <Dialog onOpenChange={onClose} open>
      <DialogContent
        className="w-full max-w-120"
        noCloseButton
        noScrollPrevention
      >
        <DialogHeader className="items-center space-y-0">
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription className="text-base">
            {description}
          </DialogDescription>
        </DialogHeader>
        <Form {...form}>
          <form className="space-y-5" onSubmit={form.handleSubmit(onSubmit)}>
            <SalesCategoryNameField
              control={form.control}
              disabled={isSubmitting}
            />

            <div className="grid grid-cols-2 gap-3">
              <Button
                onClick={onClose}
                size="lg"
                type="button"
                variant="outline"
              >
                Cancel
              </Button>
              <Button disabled={isSubmitting} size="lg" type="submit">
                {submitLabel}
              </Button>
            </div>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
};
